<template>
  <div class="contact-form-container">
    <h2>お問い合わせ</h2>
    <form @submit.prevent="submitForm" class="contact-form">
      <div class="form-group">
        <label for="name">お名前 *</label>
        <input 
          id="name"
          v-model="formData.name" 
          type="text" 
          required
          class="form-input"
        >
      </div>
      
      <div class="form-group">
        <label for="email">メールアドレス *</label>
        <input 
          id="email"
          v-model="formData.email" 
          type="email" 
          required
          class="form-input"
        >
      </div>
      
      <div class="form-group">
        <label for="company">会社名</label>
        <input 
          id="company"
          v-model="formData.company" 
          type="text"
          class="form-input"
        >
      </div>
      
      <div class="form-group">
        <label for="phone">電話番号</label>
        <input 
          id="phone"
          v-model="formData.phone" 
          type="tel"
          class="form-input"
        >
      </div>
      
      <div class="form-group">
        <label for="message">お問い合わせ内容 *</label>
        <textarea 
          id="message"
          v-model="formData.message" 
          required
          class="form-input"
          rows="5"
        ></textarea>
      </div>
      
      <div class="form-actions">
        <button type="submit" class="submit-button" :disabled="isSubmitting">
          {{ isSubmitting ? '送信中...' : '送信する' }}
        </button>
      </div>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <div v-if="success" class="success-message">
        お問い合わせを受け付けました。
      </div>
    </form>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { auth } from '../firebase'

export default {
  name: 'ContactForm',
  setup() {
    const formData = reactive({
      name: '',
      email: '',
      company: '',
      phone: '',
      message: ''
    })
    
    const error = ref('')
    const success = ref(false)
    const isSubmitting = ref(false)
    
    const submitForm = async () => {
      try {
        isSubmitting.value = true
        error.value = ''
        success.value = false
        
        // 認証済みユーザーからIDトークンを取得
        const token = auth.currentUser ? await auth.currentUser.getIdToken() : null
        
        const response = await fetch('https://submit-contact-hb4rw2utba-an.a.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
          },
          body: JSON.stringify(formData)
        })
        
        const data = await response.json()
        
        if (!response.ok) {
          throw new Error(data.error || 'お問い合わせの送信に失敗しました')
        }
        
        // フォームをリセット
        Object.keys(formData).forEach(key => formData[key] = '')
        success.value = true
        
      } catch (e) {
        error.value = e.message
      } finally {
        isSubmitting.value = false
      }
    }
    
    return {
      formData,
      error,
      success,
      isSubmitting,
      submitForm
    }
  }
}
</script>

<style scoped>
.contact-form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  color: #39FF14;
  text-align: center;
  margin-bottom: 30px;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

label {
  color: #39FF14;
  font-size: 0.9em;
}

.form-input {
  padding: 10px;
  border: 1px solid #39FF14;
  background-color: rgba(57, 255, 20, 0.1);
  color: #39FF14;
  border-radius: 4px;
  font-family: 'Courier New', Courier, monospace;
}

.form-input:focus {
  outline: none;
  border-color: #39FF14;
  box-shadow: 0 0 5px rgba(57, 255, 20, 0.5);
}

textarea.form-input {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.submit-button {
  padding: 10px 30px;
  background-color: transparent;
  border: 1px solid #39FF14;
  color: #39FF14;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Courier New', Courier, monospace;
}

.submit-button:hover:not(:disabled) {
  background-color: rgba(57, 255, 20, 0.2);
}

.submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.error-message {
  color: #ff4444;
  text-align: center;
  margin-top: 10px;
}

.success-message {
  color: #39FF14;
  text-align: center;
  margin-top: 10px;
}
</style> 